import { render, staticRenderFns } from "./DadosForm.vue?vue&type=template&id=cb0e7d20&"
import script from "./DadosForm.vue?vue&type=script&lang=js&"
export * from "./DadosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports